import {DevicesInfo} from "@share/web-conferences/types/DevicesInfo";

const storageKey = () => {
    return 'appercode_devices';
}

export const getDevicesFromStorage = (): DevicesInfo => {
    const storageData = localStorage.getItem(storageKey()) || "{}";
    let result: DevicesInfo = {};
    try {
        result = JSON.parse(storageData) as DevicesInfo;
    }
    catch (e) {
        result = {};
    }
    return result;
}

export const setDevicesToStorage = (device: DevicesInfo): void => {
    localStorage.setItem(storageKey(), JSON.stringify(device));
}